import { render, staticRenderFns } from "./LienView.vue?vue&type=template&id=36f95972&scoped=true&"
import script from "./LienView.vue?vue&type=script&lang=ts&"
export * from "./LienView.vue?vue&type=script&lang=ts&"
import style0 from "./LienView.vue?vue&type=style&index=0&id=36f95972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f95972",
  null
  
)

export default component.exports